<mat-card class="card-table has-progress-bar">
  <mat-progress-bar [mode]="loading ? 'indeterminate' : 'determinate'"></mat-progress-bar>
  <mat-card-title
    fxLayout="row"
    fxLayoutAlign="space-between center"
    *ngIf="options.title"
  >
    <span fxFlex>{{ options.title | translate }}</span>
    <ng-container *ngIf="templateByName('__actions') as actionsTemplate">
      <ng-container *ngTemplateOutlet="actionsTemplate.template"></ng-container>
    </ng-container>
  </mat-card-title>
  <mat-card-content>
    <div
      class="advanced-table--filters"
      *ngIf="options.filtering && showFilters"
    >
      <ng-content></ng-content>
    </div>

    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      [matSortActive]="matSortActive"
      matSortDirection="desc"
      matSortDisableClear
      (matSortChange)="sortData($event)"
      class="mat-table--wide"
      [class.mat-table--actionable]="options.rowClickable"
      [class.mat-table--hover]="options.rowClickable"
    >
      <ng-container
        [matColumnDef]="column.key"
        *ngFor="let column of columns; let i = index"
      >
        <ng-container *ngIf="column.canSort; else noSort">
          <th mat-header-cell *matHeaderCellDef [mat-sort-header]="column.key">
            {{ column.verboseName | translate }}
          </th>
        </ng-container>
        <ng-template #noSort>
          <th mat-header-cell *matHeaderCellDef>
            {{ column.verboseName | translate }}
          </th>
        </ng-template>
        <td
          mat-cell
          [style.maxWidth.px]="options?.maxCellWidth"
          [style.minWidth.px]="options?.minCellWidth"
          *matCellDef="let element"
        >
          <!-- Begin cell output -->
          <ng-container
            *ngIf="templateForColumn(column) as cellTemplate; else noTemplate"
          >
            <!-- With template outlet -->
            <ng-container
              *ngTemplateOutlet="
                cellTemplate.template;
                context: {
                  record: element,
                  $implicit: column.propertyAccessor
                    ? column.propertyAccessor(get(element, column.key), element)
                    : get(element, column.key)
                }
              "
            ></ng-container>
          </ng-container>
          <ng-template #noTemplate>
            <ng-template #withPropAccessor>
              <ng-container *ngIf="column.propertyAccessor(element[column.key], element) as value; else none">
                <ng-container *ngIf="column.isArray; else singleValueWithPropAccessor">
                  <div fxLayout="column">
                    <ng-container
                      *ngTemplateOutlet="propTypeArrayOutput; context: { values: value, column: column, record: element }"></ng-container>
                  </div>
                </ng-container>
                <ng-template #singleValueWithPropAccessor>
                  <ng-container
                    *ngTemplateOutlet="propTypeOutput; context: { value: value, column: column, record: element }"></ng-container>
                </ng-template>
              </ng-container>
            </ng-template>

            <ng-container *ngIf="!column.propertyAccessor; else withPropAccessor">
              <div fxLayout="column">
                <ng-container *ngTemplateOutlet="propTypeOutput; context: { value: get(element, column.key), column: column, record: element }"></ng-container>
                <ng-container *ngIf="column.secondary">
                  <span class="text-secondary text-sm">{{
                    get(element, column.secondary)
                  }}</span>
                </ng-container>
              </div>
            </ng-container>
          </ng-template>
        </td>
      </ng-container>

      <tr
        [ngClass]="[options.styles.tableHeaderClass]"
        mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: options.styles.stickyHeader"
      ></tr>

      <tr
        mat-row
        (click)="rowClicked(row, $event)"
        [style.height]="options.styles.tableRowHeight"
        class="{{
          selection.isSelected(row) ? options.styles.selectedRowClass : ''
        }}"
        [class.selectable]="options.selection"
        [ngClass]="options.rowClass ? options.rowClass(row) : []"
        *matRowDef="let row; columns: displayedColumns"
      ></tr>
    </table>

    <ng-container *ngIf="empty">
      <div class="ngx-mat-table-empty-data">
        <ng-container *ngIf="noDataTemplate; else emptyDataTmp">
          <ng-container *ngTemplateOutlet="noDataTemplate"></ng-container>
        </ng-container>
      </div>
    </ng-container>

    <ng-container *ngIf="!dataSource || loading === true">
      <div class="ngx-mat-table-loading-data">
        <ng-container *ngIf="loadingTemplate">
          <ng-container *ngTemplateOutlet="loadingTemplate"></ng-container>
        </ng-container>
        <ng-container *ngIf="!loadingTemplate">
          <div fxLayout="row" class="mt-6">
            <mat-spinner
              mode="indeterminate"
              class="ml-6 mr-2"
              [diameter]="20"
            ></mat-spinner>
            <strong>{{ options.loadingText | translate }}...</strong>
          </div>
        </ng-container>
      </div>
    </ng-container>

    <mat-paginator
      *ngIf="options.paging"
      [length]="total"
      [pageSize]="options.defaultPageSize"
      [pageSizeOptions]="[10, 15, 20, 50, 100]"
      [hidePageSize]="
        dataSource && dataSource.data && dataSource.data.length === total
      "
      [disabled]="
        dataSource && dataSource.data && dataSource.data.length === total
      "
      (page)="handlePageChange($event)"
    >
    </mat-paginator>
  </mat-card-content>
</mat-card>

<ng-template
  #propTypeOutput
  let-column="column"
  let-value="value"
  let-record="record"
>
  <ng-container [ngSwitch]="column.propertyType">
    <span *ngSwitchCase="'String'" [title]="value">
      {{ (value | translate) || (options.placeholder | translate) }}
    </span>
    <span *ngSwitchCase="'RouterLink'">
      <a [routerLink]="column.link(record)">{{
        value ||
          (column.placeholder | translate) ||
          (options.placeholder | translate)
      }}</a>
    </span>
    <span *ngSwitchCase="'Link'">
      <a [href]="column.link(record)">{{
        value ||
          (column.placeholder | translate) ||
          (options.placeholder | translate)
      }}</a>
    </span>
    <span *ngSwitchCase="'Number'">
      <ng-container *ngIf="column.format">
        {{
          (value | normalizeDecimal | number: column.format) ||
            (column.placeholder | translate) ||
            (options.placeholder | translate)
        }}
      </ng-container>
      <ng-container *ngIf="!column.format">
        <ng-container *ngIf="value != null">
          {{ value }}
        </ng-container>
        <ng-container *ngIf="value == null">
          {{ 
            (column.placeholder | translate) ||
            (options.placeholder | translate)
          }}
        </ng-container>
      </ng-container>
    </span>
    <span *ngSwitchCase="'Date'">
      <ng-container *ngIf="column.format; else momentDate">
        {{
          (value | date: column.format) ||
            (column.placeholder | translate) ||
            (options.placeholder | translate)
        }}
      </ng-container>
      <ng-template #momentDate>
        {{
          (value | momentDate: timezone) ||
            (column.placeholder | translate) ||
            (options.placeholder | translate)
        }}
      </ng-template>
    </span>
    <span *ngSwitchCase="'DateTime'">
      <span>
        {{
          (value | momentDateTime: timezone) ||
            (column.placeholder | translate) ||
            (options.placeholder | translate)
        }}
      </span>
    </span>
    <span *ngSwitchCase="'Currency'">
      {{
        (value | currency: column.format(record)) ||
          (column.placeholder | translate) ||
          (options.placeholder | translate)
      }}
    </span>
    <span *ngSwitchCase="'Telephone'">
      <a *ngIf="value" href="tel:{{ value }}">{{ value }}</a>
      <!-- TODO: use phone pipe -->
      <ng-container *ngIf="!value">{{
        (column.placeholder | translate) || (options.placeholder | translate)
      }}</ng-container>
    </span>
    <span *ngSwitchCase="'Email'">
      <a *ngIf="value" href="mailto:{{ value }}">{{ value }}</a>
      <ng-container *ngIf="!value">{{
        (column.placeholder | translate) || (options.placeholder | translate)
      }}</ng-container>
    </span>
    <span *ngSwitchCase="'Object'">
      {{
      (value | json) ||
      (column.placeholder | translate) ||
      (options.placeholder | translate)
      }}
    </span>
    <span *ngSwitchCase="'Array'">
      {{
      formatArray(value) ||
      (column.placeholder | translate) ||
      (options.placeholder | translate)
      }}
    </span>
    <span *ngSwitchDefault>
      <ng-container *ngIf="column.propertyAccessor">
        <span [innerHTML]="value | translate"></span>
      </ng-container>
      <ng-container *ngIf="!column.propertyAccessor">
        {{
          (value | translate) ||
            (column.placeholder | translate) ||
            (options.placeholder | translate)
        }}
      </ng-container>
      <!-- Default type -->
    </span>
  </ng-container>
</ng-template>

<ng-template
  #propTypeArrayOutput
  let-column="column"
  let-values="values"
  let-record="record"
>
  <ng-container *ngFor="let value of values">
    <ng-container *ngTemplateOutlet="propTypeOutput; context: { value: value, column: column, record: element }"></ng-container>
  </ng-container>
</ng-template>

<ng-template #emptyDataTmp>
  <div class="no-data mt-6 ml-6" fxLayout="row" fxLayoutAlign="start center">
    <mat-icon color="warn">warning</mat-icon>
    <span style="padding-left: 5px">
      {{ options.emptyDataText | translate }}
    </span>
  </div>
</ng-template>
